/* eslint-disable max-len */
import * as React from 'react';
import { Input, InputGroup, InputGroupText, Label } from 'reactstrap';
import '../assets/style/SearchBox.css';

interface ISearchBoxProps {
  placeHolder: string;
  label?: string;
  icon?: React.ReactElement;
  value?: string | number;
  onChange?: (e: any) => void;
  numberOnly?: boolean;
  readOnly?: boolean;
  onClick?: (event: any) => void;
  className?: string;
}

const SearchBox: React.FunctionComponent<ISearchBoxProps> = (props) => {
  return (
    <button
      className={
        props.className ? props.className : 'mb-3 button-container w-100'
      }
      onKeyDown={(event: any) => {
        if (props.onClick) {
          props.onClick(event);
        }
      }}
      onClick={(event: any) => {
        if (props.onClick) {
          props.onClick(event);
        }
      }}
    >
      {props.label && (
        <Label className="mb-1 text-start search-label">{props.label}</Label>
      )}
      <InputGroup className="input-group-parent">
        <Input
          aria-label={props.label}
          type={props.numberOnly ? 'number' : 'text'}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeHolder}
          readOnly={props.readOnly ?? false}
          className={`border-end-0 input-control form-control-search-box ${props.readOnly ? 'pointer-none' : ''}`}
        />
        <InputGroupText>{props.icon}</InputGroupText>
      </InputGroup>
    </button>
  );
};

export default SearchBox;
